declare const __webpack_public_path__: string;

export function deployUrl(path: string): string {
  return `${__webpack_public_path__ || './'}${path}`;
}
